export default {
  data: [
    {
      id: 1,
      name: "Hollie",
      email: "hdale0@themeforest.net",
      birth_date: "2011-01-21",
      gender: "Female",
      phone: "985-832-9185",
      created: "2019-05-08",
      updated: "2019-07-24"
    },
    {
      id: 2,
      name: "Darn",
      email: "drickard1@de.vu",
      birth_date: "1992-07-31",
      gender: "Male",
      phone: "163-256-6332",
      created: "2019-05-19",
      updated: "2019-12-30"
    },
    {
      id: 3,
      name: "Vallie",
      email: "vhirthe2@flavors.me",
      birth_date: "2005-07-07",
      gender: "Female",
      phone: "577-213-5876",
      created: "2019-07-29",
      updated: "2019-09-10"
    },
    {
      id: 4,
      name: "Katleen",
      email: "kkaradzas3@google.com.br",
      birth_date: "2011-07-16",
      gender: "Female",
      phone: "157-331-6768",
      created: "2019-05-11",
      updated: "2019-08-27"
    },
    {
      id: 5,
      name: "Thomasa",
      email: "tstiebler4@soup.io",
      birth_date: "1980-12-25",
      gender: "Female",
      phone: "402-496-5518",
      created: "2019-12-10",
      updated: "2019-07-27"
    },
    {
      id: 6,
      name: "Meredith",
      email: "mmawditt5@t-online.de",
      birth_date: "2005-06-17",
      gender: "Male",
      phone: "485-304-7888",
      created: "2019-03-20",
      updated: "2019-05-09"
    }
  ]
};
